import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { shareReplay, tap } from 'rxjs/operators';

interface Configuration {
  resourceServerA: string;
  resourceServerB: string;
  stage: string;
}

@Injectable({
  providedIn: 'root'
})
export class CiCdConfigService {

  private readonly CONFIG_URL = 'assets/ci-cd-config/configuration.json';
  private readonly CONFIG_URL_PRODUCTION = 'assets/ci-cd-config/configuration.production.json';
  private configuration$!: Observable<Configuration>;

  constructor(private http: HttpClient) {
  }

  public loadConfigurations(): Observable<Configuration> {
    if (!this.configuration$) {
      const url: string = this.CONFIG_URL;
      //console.log('url', url);
      this.configuration$ = this.http.get<Configuration>(`${url}`).pipe(
        tap((configuration: Configuration) => {
          //console.log('configuration', configuration);
        }),
        shareReplay(1)
      );
    }
    return this.configuration$;
  }
}
